import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-cream-50 border-t border-cream-200" data-id="element-33">
      <div className="max-w-2xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-800 mb-10 text-center" data-id="element-36">
            The moment this is for
          </h2>

          <div className="space-y-8 text-lg text-stone-600 leading-relaxed" data-id="element-37">
            <p data-id="element-38">
              This is for the woman who is tired of being surprised by her own
              body.
            </p>

            <p data-id="element-39">Not surprised in a cute way.</p>

            <div className="pl-6 border-l-2 border-terracotta/30 italic text-stone-700 font-serif text-xl" data-id="element-40">
              Surprised in a way that makes you not want photos. Surprised in a
              way that makes you buy another “forgiving” outfit. Surprised in a
              way that makes you think, I am doing everything and it is not
              working.
            </div>

            <p data-id="element-41">Your body used to respond. Now it feels like it does not.</p>

            <p className="font-medium text-stone-800" data-id="element-42">
              And that is the most maddening part. Because it makes you question
              yourself.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}